import React from 'react';

const HistoryHeaderIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-history-header" />
    </div>
  );
};

export default HistoryHeaderIcon;
